export default "__VITE_ASSET__BCUoP3hS__"